import { useState as r, useEffect as i, useCallback as a } from "react";
const n = (s, t, c) => {
  const [u, e] = r(!1);
  i(() => {
    c && e(!1);
  }, [c]);
  const l = a(
    (...f) => {
      e(!0), s && s(...f);
    },
    [e, s]
  ), o = a(
    (...f) => {
      e(!1), t && t(...f);
    },
    [e, t]
  );
  return { focused: u, handleFocus: l, handleBlur: o };
};
export {
  n as useFieldFocus
};
